import * as React from "react";
import { ArrowRight, Droplets, Flame, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Live-in Care",
  description: "Round-the-clock professional support in the comfort of your own home, ensuring safety, companionship, and peace of mind for you and your family.",
  image: "https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/2.jpeg?v=1moloylg9x2",
  icon: Droplets,
  link: "/ServicesPage"
}, {
  title: "Personal Care",
  description: "Dignified assistance with daily routines, including bathing, dressing, and medication management, delivered with compassion and respect.",
  image: "https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/5.jpeg?v=7ejxu1l3xw8",
  icon: Flame,
  link: "/ServicesPage"
}, {
  title: "Respite Care",
  description: "Essential temporary relief for primary caregivers, providing high-quality professional care while you take a well-deserved break.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/respite_care_services.png",
  icon: Wrench,
  link: "/ServicesPage"
}];
export default function Services() {
  return <section data-section-id="245009" id="full-range-of-support" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <Badge variant="secondary" className="mb-4 bg-secondary text-secondary-foreground font-default">
            CQC Registered Provider
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Full Range of Support
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Cynthylee Health Care provides premium, compassionate home care services across Brighton & Hove, tailored to meet the unique needs of every individual we serve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => <Card key={index} data-index={index} className="flex flex-col overflow-hidden border-border bg-card shadow-md hover:shadow-lg transition-shadow duration-300 rounded-lg">
              <AspectRatio ratio={16 / 9}>
                <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className={`${index === 0 || index === 1 ? "object-contain" : "object-cover"} w-full h-full !text-[rgba(24,31,37,0.52)]`} loading="lazy" />
              </AspectRatio>
              <CardHeader className="pb-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-4">
                  <service.icon className="w-6 h-6" />
                </div>
                <CardTitle className="font-default text-xl text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow pb-6">
                <p className="text-muted-foreground leading-relaxed font-default">
                  {service.description}
                </p>
              </CardContent>
              <CardFooter className="pt-0 mt-auto">
                <Button asChild variant="outline" className="w-full group border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-lg">
                  <Link to={service.link}>
                    Learn More
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="px-8 bg-primary text-primary-foreground hover:opacity-90 rounded-lg shadow-md">
            <Link to="/ServicesPage">
              View All Care Services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}